import React from 'react'
import Icon from '../Icon'

/**
* History icon.
*/
function HistoryIcon(props) {
  const { ...rest } = props

  return (
    <Icon
      icon="history"
      aria-hidden
      role="presentation"
      {...rest}
    >
      <g><path opacity=".9" d="M13 3c-4.97 0-9 4.03-9 9h-3l3.89 3.89.07.14 4.04-4.03h-3c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42c1.63 1.63 3.87 2.64 6.36 2.64 4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08v-4.25h-1.5z" /></g>
    </Icon>
  )
}

export default HistoryIcon
